var render, staticRenderFns
import script from "./Skeleton.vue?vue&type=script&lang=ts&"
export * from "./Skeleton.vue?vue&type=script&lang=ts&"
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=68962bbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports